import React from 'react'
import './CourseLableBox.css'
import { Link } from 'react-router-dom'
export default function CourseLableBox({ courseData }) {
    return (
        <div className='course-lable-box'>
            <div className='course-lable-tags'>
                <div className='course-lable-title'>
                    <h3>دسته بندی ها</h3>
                </div>
                <div className='course-tags'>
                    <Link to={"/search/all/" + courseData.category?.title}>
                        <span>{courseData.category?.title}</span>
                    </Link>
                </div>
            </div>

        </div>
    )
}
